import WalletChecker from "./WalletChecker.svelte";
import './index.css'

const getLanguageCodeFromUrl = () => {
  const languageCodePathSection = new URL(document.URL).pathname.slice(1).split('/')[0];
  return languageCodePathSection.length == 2 ? languageCodePathSection : "en";
}

const getInitialNetworkFromPage = () => document.getElementsByClassName("wallet-checker")[0]?.getAttribute("network-id") ?? "btc-mainnet";

const app = new WalletChecker({
  target: document.getElementsByClassName('wallet-checker')[0],
  props: {
    language: getLanguageCodeFromUrl(),
    initialNetwork: getInitialNetworkFromPage()
  }
});